// extracted by css-extract-rspack-plugin
export default {"wrapper":"qCHx7","no_ad_label":"ZEsD1","noAdLabel":"ZEsD1","remaining_days":"ddvzo","remainingDays":"ddvzo"};